import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSquircleButton } from './SquircleButton.definition';
import { chameleonSvg } from '../Svg';
import { chameleonPopoverV2 } from '../PopoverV2/PopoverV2.definition';
import { chameleonButton } from '../Button/Button.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonSquircleButton({ prefix }), chameleonButton({ prefix }), chameleonSvg({ prefix }), chameleonPopoverV2({ prefix }));
}
